import { pageInfo, editDetails, editData } from '../api';
import { plant,supplierList } from '../../../../../api'

const purchOrder = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null,
    supplierObj: null,
    initUpdateObj: null,
    editResp: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    SUPPLIER_LIST(state, data) {
      state.supplierObj = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async supplierList({commit}, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER_LIST', resp);
    },
    async editDetails({commit}, obj){
      let resp = await editDetails(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    }
  }
}
export default purchOrder



// WEBPACK FOOTER //
// ./src/page/bd/order/purchOrder/store/purchOrder.store.js